import { Controller } from "@hotwired/stimulus"

// Circle-wipe transition entre pages (home/landing/storytelling/explore/dashboard/builder)
// Exit : circle wipe expand sur les liens annotés data-action="click->circle-transition#navigate"
// Entrance : overlay sombre qui se dissipe (continuité visuelle avec le circle-wipe)
// Coordination : sessionStorage flag + body attr pour éviter les doublons avec page-transition
export default class extends Controller {
  connect() {
    if (this._prefersReducedMotion()) return

    // Restaurer l'état au retour arrière (bfcache)
    this._handlePageShow = this._restoreOnPageShow.bind(this)
    window.addEventListener('pageshow', this._handlePageShow)

    // Entrance seulement si on vient d'un circle-wipe
    if (sessionStorage.getItem('circle-wipe-active') !== '1') return
    sessionStorage.removeItem('circle-wipe-active')

    // Signaler à page-transition de ne pas faire son entrance
    this.element.dataset.skipPageTransition = 'true'

    // Overlay sombre qui continue visuellement le circle-wipe
    // (même couleur oklch(0.07 0 0) que .circle-wipe dans le CSS)
    const overlay = document.createElement('div')
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:oklch(0.07 0 0);z-index:9998;pointer-events:none;transition:opacity 0.4s ease-out'
    document.body.appendChild(overlay)

    // Restaurer le body (pré-caché par script inline dans les layouts)
    this.element.style.opacity = ''

    requestAnimationFrame(() => {
      overlay.style.opacity = '0'
      overlay.addEventListener('transitionend', () => {
        overlay.remove()
        delete this.element.dataset.skipPageTransition
      }, { once: true })
    })
  }

  navigate(event) {
    const link = event.currentTarget
    const url = link.href || link.dataset.href
    if (!url) return

    event.preventDefault()

    // Reduced motion : navigation immédiate
    if (this._prefersReducedMotion()) {
      window.location.href = url
      return
    }

    // Signaler l'entrance sur la prochaine page
    sessionStorage.setItem('circle-wipe-active', '1')

    // Créer le circle wipe overlay
    const circle = document.createElement("div")
    circle.classList.add("circle-wipe")
    document.body.appendChild(circle)

    // Fade-out du contenu
    const content = this._contentElement()
    if (content) {
      content.style.transition = "opacity 0.4s ease-out"
      content.style.opacity = "0"
    }

    // Lancer le circle wipe expand
    requestAnimationFrame(() => {
      circle.classList.add("go")
    })

    // Naviguer après 450ms (le circle couvre l'écran)
    setTimeout(() => {
      window.location.href = url
    }, 450)
  }

  disconnect() {
    if (this._handlePageShow) {
      window.removeEventListener('pageshow', this._handlePageShow)
    }
  }

  // Restaurer la visibilité au retour arrière (bfcache)
  // Le navigate() met opacity:0 sur <main> avant de quitter la page.
  // Au retour via bouton navigateur, le bfcache restaure cet état figé.
  _restoreOnPageShow(event) {
    if (!event.persisted) return

    // Retirer le circle-wipe résiduel
    document.querySelectorAll('.circle-wipe').forEach(el => el.remove())

    // Restaurer l'opacité du contenu
    const content = this._contentElement()
    if (content) {
      content.style.transition = ''
      content.style.opacity = ''
    }
  }

  // <main> dans dashboard, .drawer-content dans builder (pas de <main>)
  _contentElement() {
    return document.querySelector("main") || document.querySelector(".drawer-content")
  }

  _prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches
  }
}
